
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { PolicyWithProfile } from "@/components/admin/contact/policy/types/policy";

export const usePolicyData = (id?: string) => {
  const [policies, setPolicies] = useState<PolicyWithProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchPolicies = async () => {
      if (!id) {
        setLoading(false);
        return;
      }

      try {
        const { data, error: policiesError } = await supabase
          .from("policies")
          .select(`
            *,
            producer:profiles!policies_producer_id_fkey (
              first_name,
              last_name
            )
          `)
          .eq("user_id", id);

        if (policiesError) {
          throw policiesError;
        }

        setPolicies(data as PolicyWithProfile[] || []);
        setError(null);
      } catch (err) {
        console.error("Error fetching policies:", err);
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchPolicies();
  }, [id]);

  return { policies, loading, error };
};
